import { customElement, FASTElement, observable } from '@microsoft/fast-element';
import { MoreInfoIconTemplate as template } from './more-info-icon.template';
import { MoreInfoIconStyles as styles } from './more-info-icon.styles';

@customElement({
  name: 'more-info-icon',
  template,
  styles,
})

/**
 * Dynamic icon that opens a more info modal when clicked.
 * Should only be visible on the currently active tab
 *
 * @param moreInfoHeader - string from utils/enums/more-info.enum
 */
export class MoreInfoIcon extends FASTElement {
  @observable public moreInfoIcon: HTMLElement;
  @observable isVisible: boolean;
  @observable size: string;
  moreInfoItem: string;

  public openMoreInfo() {
    const detail = {item: this.moreInfoItem};
    this.$emit('openMoreInfoModal', detail);
  }
}
